/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const SignatureIcon = ({
  className,
  style,
  color = '#262626',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="20"
      height="20"
      fill="none"
    >
      <g fill={color} clipPath="url(#a)">
        <path d="M10.724 2.227a1.975 1.975 0 0 1-1.382-.578A1.933 1.933 0 0 1 8.776.273a.271.271 0 0 0-.08-.193.277.277 0 0 0-.472.193c.003.515-.2 1.01-.566 1.376a1.975 1.975 0 0 1-1.382.578.277.277 0 0 0-.195.08.271.271 0 0 0 .195.466c.52.004 1.017.212 1.382.579.366.366.57.86.566 1.375 0 .072.03.142.081.193a.277.277 0 0 0 .47-.193c-.002-.515.201-1.01.567-1.376a1.975 1.975 0 0 1 1.382-.578.277.277 0 0 0 .195-.08.271.271 0 0 0-.195-.466ZM15.276 3.773c.52.004 1.017.212 1.382.579.365.366.57.86.566 1.375 0 .072.03.142.081.193a.277.277 0 0 0 .47-.193c-.002-.515.201-1.01.567-1.376a1.975 1.975 0 0 1 1.382-.578.277.277 0 0 0 .195-.08.271.271 0 0 0-.195-.466 1.975 1.975 0 0 1-1.382-.579 1.933 1.933 0 0 1-.566-1.375.271.271 0 0 0-.08-.193.277.277 0 0 0-.472.193c.003.515-.2 1.01-.566 1.376a1.975 1.975 0 0 1-1.382.578.277.277 0 0 0-.195.08.271.271 0 0 0 .195.466ZM1.276 7.773c.52.005 1.017.213 1.382.579.366.366.57.86.566 1.375 0 .073.03.142.081.193a.277.277 0 0 0 .47-.193c-.002-.514.201-1.01.567-1.376a1.975 1.975 0 0 1 1.382-.578.277.277 0 0 0 .195-.08.271.271 0 0 0-.195-.466 1.975 1.975 0 0 1-1.382-.578 1.933 1.933 0 0 1-.566-1.376.271.271 0 0 0-.08-.193.277.277 0 0 0-.472.193c.003.515-.2 1.01-.565 1.376a1.975 1.975 0 0 1-1.383.579.277.277 0 0 0-.195.08.271.271 0 0 0 .195.465ZM1.484 19.982l2.908-.954a.696.696 0 0 0 .28-.173L11.49 12 8.774 9.284l-6.798 6.838a.721.721 0 0 0-.184.326l-.78 3.094c-.07.278.2.53.472.44Z" />
        <path d="m15.5 6.626-1.375-1.374c-.331-.331-1.004-.336-1.33-.013l-3.35 3.37 2.716 2.716 1.055-1.061.514.517a.32.32 0 0 1 0 .45l-.832.83-.675.673-2.822 2.815a.636.636 0 0 0 .447 1.083.637.637 0 0 0 .45-.186l4.329-4.32c.618-.617.62-1.623.003-2.241l-.519-.522 1.4-1.407c.325-.326.32-.998-.012-1.33Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
